// Gestione veste: ACCENTO (colore tema) + MODO (chiaro/scuro/sistema).
// L'accento usa id NUOVI (arancio/blu/verde/rosso/magenta) per non collidere coi
// vecchi temi. I token neutri (chiaro/scuro) sono in theme-tokens.css.

export const THEMES = [
  { id: 'arancio', label: 'Arancione', swatch: 'linear-gradient(135deg, #FF9500, #E17400)' },
  { id: 'blu', label: 'Blu', swatch: 'linear-gradient(135deg, #3B82F6, #2563EB)' },
  { id: 'verde', label: 'Verde', swatch: 'linear-gradient(135deg, #12B981, #059669)' },
  { id: 'rosso', label: 'Rosso', swatch: 'linear-gradient(135deg, #EF4444, #DC2626)' },
  { id: 'magenta', label: 'Magenta', swatch: 'linear-gradient(135deg, #E11D74, #BE1259)' },
  { id: 'celeste', label: 'Celeste', swatch: 'linear-gradient(135deg, #38BDF8, #0EA5E9)' },
];
const THEME_IDS = THEMES.map((t) => t.id);

export const MODES = [
  { id: 'sistema', label: 'Sistema' },
  { id: 'chiaro', label: 'Chiaro' },
  { id: 'scuro', label: 'Scuro' },
];
const MODE_IDS = MODES.map((m) => m.id);

export function getTheme() {
  try {
    const v = localStorage.getItem('appTheme');
    return THEME_IDS.includes(v) ? v : 'arancio';   // vecchi id (green/blue/dark) -> arancione
  } catch (e) { return 'arancio'; }
}

export function setTheme(id) {
  const val = THEME_IDS.includes(id) ? id : 'arancio';
  try { localStorage.setItem('appTheme', val); } catch (e) {}
  document.documentElement.setAttribute('data-theme', val);
}

export function getMode() {
  try {
    const v = localStorage.getItem('appMode');
    return MODE_IDS.includes(v) ? v : 'sistema';
  } catch (e) { return 'sistema'; }
}

export function setMode(id) {
  const val = MODE_IDS.includes(id) ? id : 'sistema';
  try { localStorage.setItem('appMode', val); } catch (e) {}
  const el = document.documentElement;
  if (val === 'chiaro') el.setAttribute('data-mode', 'light');
  else if (val === 'scuro') el.setAttribute('data-mode', 'dark');
  else el.removeAttribute('data-mode');   // sistema: lascia decidere prefers-color-scheme
}

// Applica accento + modo all'avvio (chiamata da index.js).
export function initTheme() {
  setTheme(getTheme());
  setMode(getMode());
}
